import defaultAxiosClient from '../../plugins/axios';

const initialState = {
  selectedContract: []
};

const contract = {
    namespaced: true,
    state() {
        return {...initialState};
    },
    getters: {
        selectedContract: state => state.selectedContract
    },
    mutations: {
        lockAll(state) {
            state.contractWithTimeSheetInfo.forEach(contract => {
                contract.locked = true;
            });
        },
        setSelectedContract(state, payload) {
            state.selectedContract = payload;
        }
    },
    actions: {
        updateContract({commit}, data) {
            return defaultAxiosClient.patch(`/administration/contract/${data.contractId}`, data.updateContractDto)
                .then(response => {
                    if (fromUserDetail(data.from)) {
                        commit('administrationUser/updateContractInSelectedUserDetail', response.data, {root: true});
                    }
                    if (fromCustomerDetail(data.from)) {
                        commit('administrationCustomer/updateContractInSelectedCustomerDetail', response.data, {root: true});
                    }
                });
        },
        addHourlyRateToContract({commit}, data) {
            return defaultAxiosClient.patch("/administration/contract/" + data.contractId + "/hourlyrate", data.createOrderDto)
                .then(response => {
                    if (fromUserDetail(data.from)) {
                        commit('administrationUser/updateContractInSelectedUserDetail', response.data, {root: true});
                    }
                    if (fromCustomerDetail(data.from)) {
                        commit('administrationCustomer/updateContractInSelectedCustomerDetail', response.data, {root: true});
                    }
                });
        },
        updateOrder({state, commit}, updateOrderDto) {
            const contractId = state.selectedContract.contractId;
            return defaultAxiosClient.patch(`/administration/contract/${contractId}/order`, updateOrderDto)
                .then(response => {
                    commit('setSelectedContract', response.data);
                });
        },
        fetchSelectedContractById({commit}, contractId){
            return defaultAxiosClient.get(`/administration/contract/${contractId}`)
                .then(response => {
                    commit('setSelectedContract', response.data);
                    commit('administrationTimeSheet/setSelectedCustomerTimesheetInfo', response.data, {root: true});
                });
        }
    }
};

function fromUserDetail(from) {
    return from === "userDetail";
}

function fromCustomerDetail(from) {
    return from === "customerDetail";
}


export default contract;